"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9557],{

/***/ 94878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useKonamiCheatCode = function useKonamiCheatCode(matchedCodeHandler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var pattern = [
            "ArrowUp",
            "ArrowUp",
            "ArrowDown",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
            "ArrowLeft",
            "ArrowRight", 
        ];
        var currentIndex = 0;
        var onKeyUpHandler = function onKeyUpHandler(event) {
            var key = event.key;
            // is key in correct order otherwise reset
            if (key !== pattern[currentIndex]) {
                currentIndex = 0;
                return;
            }
            currentIndex += 1;
            if (pattern.length === currentIndex) {
                currentIndex = 0;
                matchedCodeHandler();
            }
        };
        document.addEventListener("keyup", onKeyUpHandler);
        return function() {
            return document.removeEventListener("keyup", onKeyUpHandler);
        };
    }, [
        matchedCodeHandler
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useKonamiCheatCode);


/***/ }),

/***/ 49557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ EasterEgg_EasterEgg; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useKonamiCheatCode.ts
var useKonamiCheatCode = __webpack_require__(94878);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/EasterEgg/EasterEgg.tsx





var FallingBunnies = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7407), __webpack_require__.e(2074), __webpack_require__.e(1324), __webpack_require__.e(8232), __webpack_require__.e(2247)]).then(__webpack_require__.bind(__webpack_require__, 72247)).then(function(mod) {
        return mod.FallingBunnies;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72247)
            ];
        }
    },
    ssr: false
});
var EasterEgg = function(props) {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var startFalling = (0,react.useCallback)(function() {
        return setShow(true);
    }, [
        setShow
    ]);
    (0,useKonamiCheatCode/* default */.Z)(startFalling);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onAnimationEnd: function() {
                return setShow(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FallingBunnies, (0,_object_spread/* default */.Z)({}, props))
        });
    }
    return null;
};
/* harmony default export */ var EasterEgg_EasterEgg = (/*#__PURE__*/(0,react.memo)(EasterEgg));

;// CONCATENATED MODULE: ./src/components/EasterEgg/index.ts



/***/ })

}]);